import { render, staticRenderFns } from "./HandlingCompletedPanel.vue?vue&type=template&id=4729002a"
import script from "./HandlingCompletedPanel.vue?vue&type=script&lang=js"
export * from "./HandlingCompletedPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports